// history.js
import { createBrowserHistory } from 'history';
const browserHistory = createBrowserHistory();
window.browserHistory = browserHistory;
export default browserHistory;
